<div class="select-partner__container">
  <input class="select-partner__input vox-text-field" type="text" [(ngModel)]="partner"
    (ngModelChange)="onModelChange($event)" [ngbTypeahead]="search" [inputFormatter]="formatPartner"
    [resultFormatter]="formatPartner" [editable]="false" id="select-partner-reset">
</div>